import { GOOGLE_ANALYTICS, PERMISSION_LEVELS } from '../const';
import { dispatch } from '../dispatcher';

// Actions
import {
  userHasPermission,
  permissionErrorAlert,
  sendGoogleAnalyticsEvents,
} from './_utils';

// Constants
import { ActionTypes } from '../constants/MogamboConstants';

// API
import * as Api from '../api';

export async function getAllStories(botId, cb = () => {}) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_VIEW)) {
    return permissionErrorAlert();
  }

  dispatch(ActionTypes.FETCH_ALL_STORIES, {
    message: 'Fetching all stories',
  });

  const response = await Api.getStory(botId);

  if (response.success) {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_SUCCESS, {
      data: response.body,
      meta: response.meta,
    });
    cb();
  } else {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_FAILED, {
      message: response.error || 'There was an error fetching stories',
    });
  }
}

/**
 * Todo: Fix this. @ankur
 * Added temporarly.  Move fetching meta data logic at one place.
 */
export async function getAllStoriesWithoutDispatch(botId, cb = () => {}) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_VIEW)) {
    return permissionErrorAlert();
  }

  const response = await Api.getStory(botId);

  if (response.success) {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_SUCCESS, {
      data: response.body,
      meta: response.meta,
    });
  } else {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_FAILED, {
      message: response.error || 'There was an error fetching stories',
    });
  }

  cb();
}

export async function makeStoryActive(storyId, additionalHeaders, callback) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_EDIT)) {
    return permissionErrorAlert('create new business');
  }

  sendGoogleAnalyticsEvents(
    GOOGLE_ANALYTICS.CATEGORY.STORY,
    GOOGLE_ANALYTICS.EVENTS.STORY_ACTIVATE,
    `story-${storyId}`,
    GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
  );

  dispatch(ActionTypes.UPDATE_STORIES, {
    message: 'Making this Skill Active',
  });

  const response = await Api.updateStory(
    storyId,
    {
      active: true,
    },
    additionalHeaders
  );

  if (response.success) {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_SUCCESS, {
      data: response.body,
      message: 'Skill Set Activated!',
      meta: response.meta,
    });
    callback && callback();
  } else {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_FAILED, {
      message:
        response.error || 'There was an error in making the skill set active',
    });
  }
}

export async function makeStoryInactive(storyId, additionalHeaders, callback) {
  if (!userHasPermission(PERMISSION_LEVELS.MOGAMBO_ALL_VIEW)) {
    return permissionErrorAlert('fetch business list');
  }

  sendGoogleAnalyticsEvents(
    GOOGLE_ANALYTICS.CATEGORY.STORY,
    GOOGLE_ANALYTICS.EVENTS.STORY_DEACTIVATE,
    `story-${storyId}`,
    GOOGLE_ANALYTICS.VALUE.SINGLE_CLICK
  );

  dispatch(ActionTypes.UPDATE_STORIES, {
    message: 'Making this skill set Inactive',
  });

  const response = await Api.updateStory(
    storyId,
    {
      active: false,
    },
    additionalHeaders
  );

  if (response.success) {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_SUCCESS, {
      data: response.body,
      message: 'Skill Set Deactivated!',
      meta: response.meta,
    });
    callback && callback();
  } else {
    dispatch(ActionTypes.RECEIVE_ALL_STORIES_FAILED, {
      message:
        response.error || 'There was an error in making the skill set inactive',
    });
  }
}

export function setCurrentScreen(screen) {
  dispatch(ActionTypes.SET_CURRENT_SCREEN, {
    screen,
  });
}
